import { createApp } from "vue";
import { createPinia } from "pinia";
import * as Sentry from "@sentry/vue";
import App from "@/App.vue";
import { router } from "@/router";
import { i18n } from "@/plugins/i18n";
import { installPrimeVue } from "@/plugins/primevue";
import { markChunkReload } from "@/utils/chunk-reload";

import "primeicons/primeicons.css";
import "@/styles/global.css";

// Rede de segurança extra: o Vite dispara `vite:preloadError` quando um import
// dinâmico (chunk) falha — típico de chunk antigo removido por um deploy novo.
// Diferimos um tick para o router.onError (que conhece a rota-alvo) assumir as
// falhas de navegação; isto cobre o caso raro de import dinâmico fora de
// navegação. Mesma guarda anti-loop (markChunkReload).
window.addEventListener("vite:preloadError", () => {
  setTimeout(() => {
    if (markChunkReload()) window.location.reload();
  }, 0);
});

const app = createApp(App);

// Error tracking (Sentry/GlitchTip). No-op quando VITE_SENTRY_DSN está vazio.
const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (sentryDsn) {
  Sentry.init({
    app,
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_GIT_SHA as string | undefined,
  });
}

app.use(createPinia());
app.use(router);
app.use(i18n);
installPrimeVue(app);
app.mount("#app");
